export interface RayTracingBenchmark {
  gpuId: string;
  game: string;
  resolution: string;
  fps: number;
  settings: string;
}

export const rayTracingBenchmarks: RayTracingBenchmark[] = [
  // RTX 5090
  { gpuId: 'rtx-5090', game: 'Cyberpunk 2077', resolution: '4K', fps: 95, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-5090', game: 'Alan Wake 2', resolution: '4K', fps: 88, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-5090', game: 'Control', resolution: '4K', fps: 120, settings: 'RT High' },
  
  // RTX 4090
  { gpuId: 'rtx-4090', game: 'Cyberpunk 2077', resolution: '4K', fps: 72, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4090', game: 'Alan Wake 2', resolution: '4K', fps: 65, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4090', game: 'Control', resolution: '4K', fps: 95, settings: 'RT High' },
  
  // RTX 5080
  { gpuId: 'rtx-5080', game: 'Cyberpunk 2077', resolution: '4K', fps: 68, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-5080', game: 'Alan Wake 2', resolution: '4K', fps: 60, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-5080', game: 'Control', resolution: '4K', fps: 88, settings: 'RT High' },
  
  // RTX 4080 Super
  { gpuId: 'rtx-4080-super', game: 'Cyberpunk 2077', resolution: '4K', fps: 58, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4080-super', game: 'Alan Wake 2', resolution: '4K', fps: 52, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4080-super', game: 'Control', resolution: '4K', fps: 78, settings: 'RT High' },
  
  // RTX 5070 Ti
  { gpuId: 'rtx-5070-ti', game: 'Cyberpunk 2077', resolution: '4K', fps: 55, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-5070-ti', game: 'Alan Wake 2', resolution: '4K', fps: 48, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-5070-ti', game: 'Control', resolution: '4K', fps: 72, settings: 'RT High' },
  
  // RTX 4080
  { gpuId: 'rtx-4080', game: 'Cyberpunk 2077', resolution: '4K', fps: 52, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4080', game: 'Alan Wake 2', resolution: '4K', fps: 46, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4080', game: 'Control', resolution: '4K', fps: 70, settings: 'RT High' },
  
  // RTX 4070 Ti Super
  { gpuId: 'rtx-4070-ti-super', game: 'Cyberpunk 2077', resolution: '4K', fps: 45, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4070-ti-super', game: 'Alan Wake 2', resolution: '4K', fps: 40, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4070-ti-super', game: 'Control', resolution: '4K', fps: 62, settings: 'RT High' },
  
  // RTX 5070
  { gpuId: 'rtx-5070', game: 'Cyberpunk 2077', resolution: '4K', fps: 42, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-5070', game: 'Alan Wake 2', resolution: '4K', fps: 38, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-5070', game: 'Control', resolution: '4K', fps: 58, settings: 'RT High' },
  
  // RTX 4070 Ti
  { gpuId: 'rtx-4070-ti', game: 'Cyberpunk 2077', resolution: '4K', fps: 40, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4070-ti', game: 'Alan Wake 2', resolution: '4K', fps: 35, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4070-ti', game: 'Control', resolution: '4K', fps: 55, settings: 'RT High' },
  
  // RTX 4070 Super
  { gpuId: 'rtx-4070-super', game: 'Cyberpunk 2077', resolution: '4K', fps: 35, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4070-super', game: 'Alan Wake 2', resolution: '4K', fps: 30, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4070-super', game: 'Control', resolution: '4K', fps: 48, settings: 'RT High' },
  
  // RTX 4070
  { gpuId: 'rtx-4070', game: 'Cyberpunk 2077', resolution: '1440p', fps: 55, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4070', game: 'Alan Wake 2', resolution: '1440p', fps: 48, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4070', game: 'Control', resolution: '1440p', fps: 72, settings: 'RT High' },
  
  // RTX 4060 Ti
  { gpuId: 'rtx-4060-ti', game: 'Cyberpunk 2077', resolution: '1440p', fps: 42, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4060-ti', game: 'Alan Wake 2', resolution: '1440p', fps: 35, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4060-ti', game: 'Control', resolution: '1440p', fps: 55, settings: 'RT High' },
  
  // RTX 4060
  { gpuId: 'rtx-4060', game: 'Cyberpunk 2077', resolution: '1080p', fps: 52, settings: 'RT Ultra, DLSS Quality' },
  { gpuId: 'rtx-4060', game: 'Alan Wake 2', resolution: '1080p', fps: 45, settings: 'RT High, DLSS Quality' },
  { gpuId: 'rtx-4060', game: 'Control', resolution: '1080p', fps: 65, settings: 'RT High' },
  
  // AMD RX 7900 XTX
  { gpuId: 'rx-7900-xtx', game: 'Cyberpunk 2077', resolution: '4K', fps: 38, settings: 'RT Ultra, FSR Quality' },
  { gpuId: 'rx-7900-xtx', game: 'Alan Wake 2', resolution: '4K', fps: 32, settings: 'RT High, FSR Quality' },
  { gpuId: 'rx-7900-xtx', game: 'Control', resolution: '4K', fps: 52, settings: 'RT High' },
  
  // AMD RX 9070 XT
  { gpuId: 'rx-9070-xt', game: 'Cyberpunk 2077', resolution: '4K', fps: 48, settings: 'RT Ultra, FSR Quality' },
  { gpuId: 'rx-9070-xt', game: 'Alan Wake 2', resolution: '4K', fps: 42, settings: 'RT High, FSR Quality' },
  { gpuId: 'rx-9070-xt', game: 'Control', resolution: '4K', fps: 62, settings: 'RT High' },
  
  // AMD RX 7900 XT
  { gpuId: 'rx-7900-xt', game: 'Cyberpunk 2077', resolution: '4K', fps: 32, settings: 'RT Ultra, FSR Quality' },
  { gpuId: 'rx-7900-xt', game: 'Alan Wake 2', resolution: '4K', fps: 28, settings: 'RT High, FSR Quality' },
  { gpuId: 'rx-7900-xt', game: 'Control', resolution: '4K', fps: 45, settings: 'RT High' },
  
  // AMD RX 9070
  { gpuId: 'rx-9070', game: 'Cyberpunk 2077', resolution: '4K', fps: 40, settings: 'RT Ultra, FSR Quality' },
  { gpuId: 'rx-9070', game: 'Alan Wake 2', resolution: '4K', fps: 35, settings: 'RT High, FSR Quality' },
  { gpuId: 'rx-9070', game: 'Control', resolution: '4K', fps: 55, settings: 'RT High' },
  
  // AMD RX 7800 XT
  { gpuId: 'rx-7800-xt', game: 'Cyberpunk 2077', resolution: '1440p', fps: 38, settings: 'RT Ultra, FSR Quality' },
  { gpuId: 'rx-7800-xt', game: 'Alan Wake 2', resolution: '1440p', fps: 32, settings: 'RT High, FSR Quality' },
  { gpuId: 'rx-7800-xt', game: 'Control', resolution: '1440p', fps: 48, settings: 'RT High' },
  
  // Intel Arc B580
  { gpuId: 'arc-b580', game: 'Cyberpunk 2077', resolution: '1080p', fps: 35, settings: 'RT Medium, XeSS Quality' },
  { gpuId: 'arc-b580', game: 'Control', resolution: '1080p', fps: 42, settings: 'RT Medium' },
  
  // Intel Arc A770
  { gpuId: 'arc-a770', game: 'Cyberpunk 2077', resolution: '1080p', fps: 30, settings: 'RT Medium, XeSS Quality' },
  { gpuId: 'arc-a770', game: 'Control', resolution: '1080p', fps: 38, settings: 'RT Medium' },
];

export function getRayTracingBenchmarks(gpuId: string): RayTracingBenchmark[] {
  return rayTracingBenchmarks.filter(b => b.gpuId === gpuId);
}
